import "./q-bank-media.scss";

export function getDeviceType(): "Desktop" | "Tablet" | "Mobile" {
    const width = window.innerWidth;

    if (width >= 1024) {
        return "Desktop";
    } else if (width >= 768) {
        return "Tablet";
    } else {
        return "Mobile";
    }
}

const deviceType = getDeviceType();
document.cookie = `deviceType=${deviceType}; path=/;`;


